<template>
  <div>
    <page-header name="Participantes">
      <b-button
        v-if="isAccessToRoleAndTypeCoupon()"
        variant="primary"
        class="mr-1"
        @click="$router.push('/coupons/create')"
      >
        <FeatherIcon icon="SendIcon" />
        &nbsp;<span class="text-nowrap">Enviar Cupons</span>
      </b-button>
      <b-button
        v-if="isAccessToRoleAndTypeCoupon()"
        class="mr-1"
        variant="primary"
        @click="$router.push('/participant-validate')"
      >
        <FeatherIcon icon="MenuIcon" />
        &nbsp;<span class="text-nowrap">Validação de Participantes</span>
      </b-button>

      <b-button
        v-if="currentPrizeDraw.promotion.settings.can_import_file && isShowButtonsFilesImport"
        variant="secondary"
        class="mr-1"
        @click="showImportDetails()"
      >
        <FeatherIcon icon="ListIcon" />
        &nbsp;<span class="text-nowrap">Histórico de Importações</span>
      </b-button>
      <b-dropdown
        v-if="currentPrizeDraw.promotion.settings.can_import_file && isShowButtonsFilesImport"
        id="dropdown-1"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        text="Participantes"
        right
        variant="primary"
      >
        <b-dropdown-item @click="importFile">
          <feather-icon
            icon="UploadCloudIcon"
            size="18"
          />&nbsp; Importar Arquivo
        </b-dropdown-item>
        <b-dropdown-item @click="updateParticipants">
          <feather-icon
            icon="RefreshCwIcon"
            size="18"
          />&nbsp; Atualizar Participantes
        </b-dropdown-item>
      </b-dropdown>
    </page-header>
    <b-row class="match-height">
      <b-col
        sm="6"
        md="4"
      >
        <chart-median-numbers-by-person :data="1"/>
      </b-col>
      <b-col
        sm="6"
        md="4"
      >
        <chart-bar-participant-per-state />
      </b-col>
      <b-col
        sm="6"
        md="4"
      >
        <chart-bar-participant-per-origin/>
      </b-col>
    </b-row>
    <b-card>
      <b-row>
        <b-col>
          <b-card-title>Participantes</b-card-title>
        </b-col>
        <b-col class="text-right">
          <b-dropdown
            id="dropdown-1"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            text="Ações"
            right
            variant="outline-secondary"
          >
            <b-dropdown-item @click="onExportSecap">
              <feather-icon
                icon="PrinterIcon"
                size="18"
              />&nbsp; Emitir Arquivo para SPA
            </b-dropdown-item>
            <b-dropdown-item @click="onExportXls">
              <feather-icon
                icon="PrinterIcon"
                size="18"
              />&nbsp; Exportar para XLS
            </b-dropdown-item>
            <b-dropdown-item @click="onOpenExportGeneratedNumbersModal">
              <feather-icon
                icon="PrinterIcon"
                size="18"
              />&nbsp; Exportar Números Gerados
            </b-dropdown-item>
            <b-dropdown-item @click="onOpenExportConsolidatedReportModal">
              <feather-icon
                icon="FileTextIcon"
                size="18"
              />&nbsp; Exportar Relatório Consolidado
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>
      <Grid
        :fields="fields"
        :items="items"
        edit-button-label="edit"
        new-button-label="new"
        :show-search="false"
        @onChangePage="getParticipants"
      >
        <template v-slot:search>
          <b-row class="p-0 pl-1">
            <b-col
              md="10"
              class="p-0 pr-1"
            >
              <b-form-input
                v-model="search.search"
                class="filter-input"
                placeholder="Pesquisar por Nome, email ou cpf"
                name="nome"
                @keyup.enter="getParticipants"
              />
            </b-col>
            <b-col
              sm="12"
              md="2"
            >
              <b-button
                variant="secondary"
                type="button"
                @click="getParticipants"
              >
                <FeatherIcon icon="SearchIcon" />
                <span
                  class="text-nowrap"
                />
              </b-button>
            </b-col>
          </b-row>
        </template>
        <template #cell(name)="data">
          <b-media vertical-align="center" style="cursor: pointer" @click="setCurrentParticipant(data.item)">
            <template #aside>
              <b-avatar
                size="32"
                :text="avatarText(data.item.name)"
              />
            </template>
            <span v-if="data.item.name ">{{ data.item.name }} <br></span>

            <small v-if="data.item.email" class="text-muted">
              <feather-icon icon="AtSignIcon"/> &nbsp; {{ data.item.email }}<br></small>
            <small v-if="data.item.username" class="text-muted">
              <feather-icon icon="UserIcon"/> &nbsp;{{ data.item.username }}</small>
          </b-media>
        </template>
        <template
          #cell(created_at)="data"
          style="width: 20%"
        >
          <div class="px-4 text-center">
            {{ data.item.created_at | moment('DD/MM/YYYY') }}
          </div>
        </template>
        <template #cell(ineligibility)="data">
          <div v-if="data.item.ineligibility">
            <b-badge pill
                     variant="danger"
            >Não
            </b-badge>
            <br>
            <small class="text-muted">{{ data.item.ineligibility_reason }}</small>
          </div>
          <b-badge
            v-if="!data.item.ineligibility"
            pill
            variant="success"
          >
            Sim
          </b-badge>
        </template>
        <template
          #cell(action)="data"
          style="width: 20%"
        >
          <div class="d-flex align-items-center justify-content-center">
            <i2-icon-button
              icon="EyeIcon"
              class="mr-1"
              @click="setCurrentParticipant(data.item)"
            />
            <i2-icon-button
              v-if="isSuperAdmin"
              variant="danger"
              @click="openCancelNumbersModal(data.item)"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="4" y1="9" x2="20" y2="9" />
                <line x1="4" y1="15" x2="20" y2="15" />
                <line x1="10" y1="3" x2="8" y2="21" />
                <line x1="16" y1="3" x2="14" y2="21" />
                <line x1="2" y1="22" x2="22" y2="2" stroke-width="2.5" />
              </svg>
            </i2-icon-button>
          </div>
        </template>
      </Grid>
    </b-card>
    <participant-detail-modal
      title="Detalhes do Participante"
      :show.sync="isShowParticipant"
      :participant-uuid="currentParticipant"
      @onClose="onCloseParticipantModal"
    />

    <b-modal
      v-model="isShowExportGeneratedNumbersModal"
      title="Exportar Números Gerados"
      cancel-title="Fechar"
      ok-title="Exportar"
      no-close-on-backdrop
      :busy="isExportingGeneratedNumbers"
      :ok-disabled="isExportGeneratedNumbersInvalid || isExportingGeneratedNumbers"
      @ok="onSubmitExportGeneratedNumbers"
    >
      <b-form>
        <b-row>
          <b-col cols="12">
            <b-form-group label="Tipo de exportação">
              <b-form-radio-group
                v-model="exportGeneratedNumbers.type"
                :options="exportGeneratedNumbersTypeOptions"
                value-field="value"
                text-field="text"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="isExportGeneratedNumbersInterval">
          <b-col sm="6">
            <b-form-group label="Série inicial" label-for="serie-start">
              <b-form-input
                id="serie-start"
                v-model.number="exportGeneratedNumbers.serie_start"
                type="number"
                min="0"
                step="1"
                placeholder="Informe a série inicial"
                :state="serieStartState"
              />
              <b-form-invalid-feedback v-if="serieStartError">
                {{ serieStartError }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label="Série final" label-for="serie-end">
              <b-form-input
                id="serie-end"
                v-model.number="exportGeneratedNumbers.serie_end"
                type="number"
                min="0"
                step="1"
                placeholder="Informe a série final"
                :state="serieEndState"
              />
              <b-form-invalid-feedback v-if="serieEndError">
                {{ serieEndError }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <b-modal
      v-model="isShowExportConsolidatedReportModal"
      title="Exportar Relatório Consolidado"
      cancel-title="Fechar"
      ok-title="Exportar"
      no-close-on-backdrop
      :busy="isExportingConsolidatedReport"
      :ok-disabled="isExportingConsolidatedReport"
      @ok="onSubmitExportConsolidatedReport"
    >
      <b-form>
        <b-row>
          <b-col cols="12">
            <b-form-group label="Escopo da exportação">
              <b-form-radio-group
                v-model="exportConsolidatedReport.scope"
                :options="exportConsolidatedReportScopeOptions"
                value-field="value"
                text-field="text"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group label="Agrupar por segmento?">
              <b-form-radio-group
                v-model="exportConsolidatedReport.group_by_segment"
                :options="exportConsolidatedReportGroupByOptions"
                value-field="value"
                text-field="text"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <b-modal
      v-model="isShowCancelNumbersModal"
      title="Cancelar Números"
      cancel-title="Fechar"
      ok-title="Cancelar números"
      ok-variant="danger"
      no-close-on-backdrop
      no-close-on-esc
      :busy="isCancelingNumbers"
      :ok-disabled="isCancelingNumbers"
      @ok="onSubmitCancelNumbers"
      @hide="onHideCancelNumbersModal"
    >
      <b-form>
        <b-form-group label="Documento" label-for="cancel-document">
          <b-form-input
            id="cancel-document"
            :value="cancelNumbersParticipant ? cancelNumbersParticipant.document : ''"
            readonly
          />
        </b-form-group>
        <b-form-group label="Quantidade" label-for="cancel-quantity">
          <b-form-input
            id="cancel-quantity"
            v-model.number="cancelNumbers.quantity"
            type="number"
            min="1"
            max="100"
            step="1"
            placeholder="Informe a quantidade de números a cancelar (máx. 100)"
            :disabled="isCancelingNumbers"
          />
        </b-form-group>
        <b-form-group label="Ordem" label-for="cancel-order">
          <b-form-select
            id="cancel-order"
            v-model="cancelNumbers.order"
            :options="cancelNumbersOrderOptions"
            :disabled="isCancelingNumbers"
          />
        </b-form-group>
        <b-form-group label="Motivo" label-for="cancel-reason">
          <b-form-textarea
            id="cancel-reason"
            v-model="cancelNumbers.reason"
            placeholder="Descreva o motivo do cancelamento"
            maxlength="500"
            rows="3"
            :disabled="isCancelingNumbers"
          />
        </b-form-group>
        <b-alert
          v-if="cancelNumbersError"
          variant="danger"
          show
        >
          {{ cancelNumbersError }}
        </b-alert>
      </b-form>
    </b-modal>

    <i2-side-bar
      :is-active.sync="isUploadActivated"
      window-title="Importar Arquivo"
    >
      <prize-draw-file-import
        :is-active.sync="isUploadActivated"
        :prize-draw="currentPrizeDraw"
        :is-update-participants="isUpdateParticipants"
        @onModelSave="onSave()"
        @onCancel="onCancelEdit()"
      />
    </i2-side-bar>
    <promotion-import-log-modal :promotion-uuid="currentPromotion.uuid" :show.sync="isShowImportLog"
                                @onClose="onCloseLogImport"
    />
  </div>
</template>
<script>

import ChartBarParticipantPerState from '@/views/dashboards/participants/ChartBarParticipantPerState.vue'
import ChartBarParticipantPerOrigin from '@/views/dashboards/participants/ChartBarParticipantPerOrigin.vue'
import ChartMedianNumbersByPerson from '@/views/dashboards/participants/ChartMedianNumbersByPerson.vue'
// eslint-disable-next-line import/no-cycle
import ParticipantDetailModal from '@/views/participants/ParticipantDetailModal'
import Ripple from 'vue-ripple-directive'
import PrizeDrawFileImport from '@/views/prize-draw/PrizeDrawFileImport'
import PromotionImportLogModal from '@/components/app/promotion/PromotionImportLogModal'
import currentUser from '@/libs/users'

export default {
  name: 'ParticipantList',
  directives: {
    Ripple,
  },
  components: {
    PromotionImportLogModal,
    PrizeDrawFileImport,
    ParticipantDetailModal,
    ChartMedianNumbersByPerson,
    ChartBarParticipantPerOrigin,
    ChartBarParticipantPerState,
  },
  data() {
    return {
      search: {
        search: '',
        type: '',
      },
      fields: [
        {
          key: 'name',
          label: 'Nome',
          class: 'w-30',
          sortable: true,
        },
        {
          key: 'document',
          label: 'Cpf',
          class: 'w-10',
          sortable: true,
        },
        {
          key: 'created_at',
          label: 'Data de Cadastro',
          class: 'w-10',
          sortable: true,
        },
        {
          key: 'state',
          label: 'UF',
          class: 'w-10',
          sortable: true,
        },
        {
          key: 'city',
          label: 'Cidade',
          class: 'w-10',
          sortable: true,
        },
        {
          key: 'luck_numbers',
          label: 'Números',
          class: 'w-10',
          sortable: true,
        },
        {
          key: 'ineligibility',
          label: 'Elegível',
          class: 'w-10',
        },
        {
          key: 'action',
          label: 'Ações',
          class: 'w-20',
        },
      ],
      items: [],
      currentClient: null,
      isShowParticipant: false,
      isShowImportLog: false,
      isShowButtonsFilesImport: false,
      currentType: '',
      currentPromotion: null,
      currentPrizeDraw: null,
      typesIndexes: [],
      isActivated: false,
      currentParticipant: '',
      isUploadActivated: false,
      isUpdateParticipants: false,
      isShowExportGeneratedNumbersModal: false,
      isExportingGeneratedNumbers: false,
      exportGeneratedNumbers: {
        type: 'all',
        serie_start: null,
        serie_end: null,
      },
      exportGeneratedNumbersTypeOptions: [
        { text: 'Todas as séries', value: 'all' },
        { text: 'Intervalo de séries', value: 'interval' },
      ],
      isShowExportConsolidatedReportModal: false,
      isExportingConsolidatedReport: false,
      exportConsolidatedReport: {
        scope: 'draw',
        group_by_segment: false,
      },
      exportConsolidatedReportScopeOptions: [
        { text: 'Sorteio atual', value: 'draw' },
        { text: 'Promoção', value: 'promotion' },
      ],
      exportConsolidatedReportGroupByOptions: [
        { text: 'Não', value: false },
        { text: 'Sim', value: true },
      ],
      numbersByParticipant: [{
        icon: 'TrendingUpIcon',
        color: 'light-success',
        title: 1,
        subtitle: '',
        customClass: 'mb-2 mb-xl-0',
      }],
      isShowCancelNumbersModal: false,
      isCancelingNumbers: false,
      cancelNumbersParticipant: null,
      cancelNumbersError: null,
      cancelNumbers: {
        quantity: 1,
        order: 'most_recent',
        reason: '',
      },
      cancelNumbersOrderOptions: [
        { value: 'most_recent', text: 'Mais recentes' },
        { value: 'least_recent', text: 'Menos recentes' },
        { value: 'random', text: 'Aleatório' },
      ],
    }
  },
  computed: {
    isSuperAdmin() {
      const user = currentUser.getCurrentUser()
      return user && user.type === 'super_admin'
    },
    isExportGeneratedNumbersInterval() {
      return this.exportGeneratedNumbers.type === 'interval'
    },
    serieStartError() {
      if (!this.isExportGeneratedNumbersInterval) {
        return ''
      }
      const { serie_start: serieStart } = this.exportGeneratedNumbers
      if (serieStart === null || serieStart === undefined || serieStart === '') {
        return 'Série inicial é obrigatória.'
      }
      if (!Number.isInteger(serieStart) || serieStart < 0) {
        return 'Série inicial deve ser um inteiro maior ou igual a zero.'
      }
      return ''
    },
    serieEndError() {
      if (!this.isExportGeneratedNumbersInterval) {
        return ''
      }
      const { serie_start: serieStart, serie_end: serieEnd } = this.exportGeneratedNumbers
      if (serieEnd === null || serieEnd === undefined || serieEnd === '') {
        return 'Série final é obrigatória.'
      }
      if (!Number.isInteger(serieEnd) || serieEnd < 0) {
        return 'Série final deve ser um inteiro maior ou igual a zero.'
      }
      if (Number.isInteger(serieStart) && Number.isInteger(serieEnd) && serieStart > serieEnd) {
        return 'Série inicial deve ser menor ou igual à série final.'
      }
      return ''
    },
    serieStartState() {
      if (!this.isExportGeneratedNumbersInterval) {
        return null
      }
      return this.serieStartError ? false : null
    },
    serieEndState() {
      if (!this.isExportGeneratedNumbersInterval) {
        return null
      }
      return this.serieEndError ? false : null
    },
    isExportGeneratedNumbersInvalid() {
      if (this.exportGeneratedNumbers.type === 'all') {
        return false
      }
      if (this.exportGeneratedNumbers.type !== 'interval') {
        return true
      }
      return Boolean(this.serieStartError || this.serieEndError)
    },
  },
  async mounted() {
    const promotion = this.$user.getCurrentPromotion()
    if (!promotion) {
      await this.$router.push(`/change-promotions?ref=${this.$route.path}`)
      return
    }
    this.currentPromotion = promotion
    const prizeDraw = this.$user.getCurrentPrizeDraw()
    if (!prizeDraw) {
      await this.$router.push(`/change-promotions?ref=${this.$route.path}`)
      return
    }
    this.currentPrizeDraw = prizeDraw
    await this.getParticipants(1)
    await this.getManagers()
    await this.hasBusinessInteligence()
  },
  methods: {
    async getParticipants(page) {
      this.items = await this.$search.get(
        'participants',
        page,
        this.search,
        'ineligibility',
      )
    },
    isAccessToRoleAndTypeCoupon() {
      const userTypes = ['super_admin', 'admin', 'user']
      const user = currentUser.getCurrentUser()
      const promotion = this.$user.getCurrentPromotion()
      const setting = promotion.settings
      if (setting.need_coupon_approval !== undefined && setting.need_coupon_approval === false) {
        return false
      }
      return (userTypes.includes(user.type) && setting.is_coupon_promotion)
    },
    avatarText(value) {
      if (!value) {
        return ''
      }
      const words = value.split(' ')
      const nameArray = [words[0]]
      if (words.length > 0) {
        nameArray.push(words[words.length - 1])
      }

      return nameArray.map(word => word.charAt(0).toUpperCase()).join('')
    },
    setCurrentParticipant(participant) {
      this.currentParticipant = participant.uuid
      this.isShowParticipant = true
    },
    onCloseParticipantModal() {
      this.currentParticipant = ''
      this.isShowParticipant = false
    },
    async onExportSecap() {
      const response = await this.$http.get(`prize-draws/${this.currentPrizeDraw.uuid}/export-secap`)
      if (!response || response.error) {
        this.$notify.error(
          (response && (response.error_message
            || response.message
            || (response.data && response.data.message)))
          || 'Não foi possível emitir o arquivo para SPA.',
        )
        return false
      }
      this.$notify.success(response.message || 'Exportação iniciada com sucesso.')
      return true
    },
    async onExportXls() {
      const search = this.$search.parseSearchString(this.search)

      const response = await this.$http.get(`/participants/export?search=${search}&include=ineligibility`)
      if (response.error) {
        this.$notify.error(response.error_message)
        return false
      }
      this.$notify.success(response.message)
      return true
    },
    onOpenExportGeneratedNumbersModal() {
      this.exportGeneratedNumbers = {
        type: 'all',
        serie_start: null,
        serie_end: null,
      }
      this.isShowExportGeneratedNumbersModal = true
    },
    async onSubmitExportGeneratedNumbers(modalEvent) {
      modalEvent.preventDefault()

      if (this.isExportGeneratedNumbersInvalid || this.isExportingGeneratedNumbers) {
        return false
      }

      this.isExportingGeneratedNumbers = true

      try {
        const queryParams = {
          type: this.exportGeneratedNumbers.type,
        }

        if (this.exportGeneratedNumbers.type === 'interval') {
          queryParams.serie_start = this.exportGeneratedNumbers.serie_start
          queryParams.serie_end = this.exportGeneratedNumbers.serie_end
        }

        const query = new URLSearchParams(queryParams).toString()
        const response = await this.$http.get(`/prize-draws/${this.currentPrizeDraw.uuid}/export-numbers?${query}`)
        if (response && response.error) {
          this.$notify.error(response.error_message || response.message || (response.data && response.data.message) || 'Não foi possível exportar os números gerados.')
          return false
        }

        if (!response) {
          this.$notify.error('Não foi possível exportar os números gerados.')
          return false
        }

        this.$notify.success(response.message || (response.data && response.data.message) || 'Exportação iniciada com sucesso.')
        this.isShowExportGeneratedNumbersModal = false
        return true
      } finally {
        this.isExportingGeneratedNumbers = false
      }
    },
    importFile() {
      this.isUploadActivated = true
      this.isUpdateParticipants = false
    },
    onSave() {
      this.isUploadActivated = false
    },
    updateParticipants() {
      this.isUploadActivated = true
      this.isUpdateParticipants = true
    },
    onCancelEdit() {
      this.isUploadActivated = false
    },
    showImportDetails() {
      this.isShowImportLog = true
    },
    onCloseLogImport() {
      this.isShowImportLog = false
    },
    onOpenExportConsolidatedReportModal() {
      this.exportConsolidatedReport = {
        scope: 'draw',
        group_by_segment: false,
      }
      this.isShowExportConsolidatedReportModal = true
    },
    async onSubmitExportConsolidatedReport(modalEvent) {
      modalEvent.preventDefault()

      if (this.isExportingConsolidatedReport) {
        return false
      }

      this.isExportingConsolidatedReport = true

      try {
        const { scope, group_by_segment: groupBySegment } = this.exportConsolidatedReport
        const query = new URLSearchParams({ group_by_segment: groupBySegment }).toString()
        const response = await this.$http.get(
          `/prize-draws/${this.currentPrizeDraw.uuid}/export-consolidated-numbers/${scope}?${query}`,
        )

        if (response && response.error) {
          this.$notify.error(
            response.error_message
            || response.message
            || (response.data && response.data.message)
            || 'Não foi possível exportar o relatório consolidado.',
          )
          return false
        }

        this.$notify.success(response.message || 'Exportação iniciada com sucesso.')
        this.isShowExportConsolidatedReportModal = false
        return true
      } finally {
        this.isExportingConsolidatedReport = false
      }
    },
    openCancelNumbersModal(participant) {
      this.cancelNumbersParticipant = participant
      this.cancelNumbersError = null
      this.cancelNumbers = { quantity: 1, order: 'most_recent', reason: '' }
      this.isShowCancelNumbersModal = true
    },
    onHideCancelNumbersModal(event) {
      if (this.isCancelingNumbers) {
        event.preventDefault()
      }
    },
    async onSubmitCancelNumbers(modalEvent) {
      modalEvent.preventDefault()

      if (this.isCancelingNumbers) {
        return
      }

      const { quantity, order, reason } = this.cancelNumbers
      if (!quantity || quantity < 1 || !Number.isInteger(quantity)) {
        this.cancelNumbersError = 'Informe uma quantidade válida (inteiro maior ou igual a 1).'
        return
      }
      if (quantity > 100) {
        this.cancelNumbersError = 'A quantidade máxima permitida é 100 números por vez.'
        return
      }
      if (!reason || !reason.trim()) {
        this.cancelNumbersError = 'O motivo é obrigatório.'
        return
      }

      this.isCancelingNumbers = true
      this.cancelNumbersError = null

      try {
        const body = {
          documents: [this.cancelNumbersParticipant.document],
          quantity,
          order,
          reason: reason.trim(),
        }

        const response = await this.$http.post(
          `prize-draws/${this.currentPrizeDraw.uuid}/cancel-numbers`,
          body,
        )

        if (response && response.error) {
          if (response.error === 403) {
            this.cancelNumbersError = 'Você não tem permissão para realizar esta ação.'
          } else if (response.data && response.data.message) {
            this.cancelNumbersError = response.data.message
          } else if (response.errors) {
            const messages = Object.values(response.errors).flat()
            this.cancelNumbersError = messages.join(' ')
          } else {
            this.cancelNumbersError = response.error_message || 'Ocorreu um erro ao cancelar os números.'
          }
          return
        }

        const totalCanceled = response && response.total_canceled != null ? response.total_canceled : '?'
        const numbers = response && response.canceled && response.canceled.length > 0
          ? response.canceled.flatMap(c => c.numbers).join(', ')
          : ''

        const successMsg = numbers
          ? `${totalCanceled} número(s) cancelado(s) com sucesso: ${numbers}`
          : `${totalCanceled} número(s) cancelado(s) com sucesso.`

        this.isCancelingNumbers = false
        this.isShowCancelNumbersModal = false
        this.$notify.success(successMsg)
        await this.getParticipants(1)
      } finally {
        this.isCancelingNumbers = false
      }
    },
    async getManagers() {
      if (!this.currentPromotion.uuid) {
        return
      }
      const response = await this.$http.get(`/promotions/${this.currentPromotion.uuid}/managers`)
      if (response && response.length > 0) {
        response.forEach(user => {
          if (user.uuid === this.$user.getCurrentUser().uuid) {
            this.isShowButtonsFilesImport = true
          }
        })
      }
    },
  },
}
</script>

<style scoped>

</style>
